__turbopack_context__.v({
  "className": "ZdMhYa_className",
  "variable": "ZdMhYa_variable",
});
